export default class FormErrors {
  static errorMessage(
    name,
    errors,
    touched,
    isSubmitted,
    externalErrorMessage = null,
    ignoredErrorTypes: any = [],
  ) {
    if (externalErrorMessage) {
      return externalErrorMessage;
    }

    if (!isSubmitted && !touched[name]) {
      return null;
    }

    let fieldErrors = errors[name];

    let fieldError =
      fieldErrors?.[0] || fieldErrors || null;

    if (ignoredErrorTypes && fieldErrors) {
      if (ignoredErrorTypes.includes(fieldError.type)) {
        return null;
      }
    }

    return fieldError?.message;
  }
}
